import React from "react";

import AcademicIncomeIcon from "../../icons/academic-income-icon";
import FeesIcon from "../../icons/income-fees-icon";
import GiftIncomeIcon from "../../icons/gifts-income-icon";
import MisIncomesIcon from "../../icons/mis-icomes-icon";
import ProjectIncomesIcon from "../../icons/projects-income-icon";
import DeptPaymentIcon from "../../icons/debt-payment-icon";
import DirectExpenseIcon from "../../icons/direct-expenses-icon";
import IndirectExpensesIcon from "../../icons/indirect-expenses-icon";
import SalaryBenefitsIcon from "../../icons/salary-benefits-icon";

import { Link } from "react-router-dom";

const CardItems = ({ cards, restClass, currentTab, path, getData }) => {
  const renderIcon = (name) => {
    switch (name) {
      case "Students Fee":
        return <FeesIcon />;
      case "Grants":
        return <ProjectIncomesIcon />;
      case "Academic Support":
        return <AcademicIncomeIcon />;
      case "Gifts":
        return <GiftIncomeIcon />;
      case "Misc Revenues":
        return <MisIncomesIcon />;
      case "Teacher Salaries":
        return <SalaryBenefitsIcon />;
      case "Staff Salaries":
        return <SalaryBenefitsIcon />;
      case "Direct Expenses":
        return <DirectExpenseIcon />;
      case "Indirect Expenses":
        return <IndirectExpensesIcon />;
      case "Debt Payments":
        return <DeptPaymentIcon />;
      default:
        return null;
    }
  };

  const renderCard = (p = new Object()) => {
    let _className = `card-item ${
      parseInt(currentTab) === p?.id ? "active" : ""
    }`;

    return (
      <Link to={`/mis/${path}/${p.id}`} key={p.id}>
        <div className={_className}>
          <div className="wrapper">
            <i>{renderIcon(p.name_en)}</i>
            <p>{p.name}</p>
          </div>
        </div>
      </Link>
    );
  };

  return (
    <div className={`card-items-area ${restClass}`}>
      {cards && cards.map((card) => renderCard(card))}
    </div>
  );
};

export default CardItems;
